import { FeatureFlagKey } from "@repo/app-types/featureFlags/keys";
import type { FC } from "react";
import { useIsFeatureFlagEnabled } from "../../../helpers/featureFlags/hooks.js";
import { BillingSettingsPage } from "./billingSettingsPage.js";
import { BillingSettingsSection } from "./billingSettingsSection.js";

/**
 * The billing settings route: the redesigned plan + AI usage page behind the
 * `new-billing` flag, the legacy billing section otherwise. The router is
 * static, so the flag gates at render time rather than route registration.
 */
export const BillingSettingsGate: FC = () => {
  const isNewBillingEnabled = useIsFeatureFlagEnabled(
    FeatureFlagKey.NewBilling,
  );

  return isNewBillingEnabled ? (
    <BillingSettingsPage />
  ) : (
    <BillingSettingsSection />
  );
};
